// extracted by mini-css-extract-plugin
export default {"container":"CampaignPlannerList_container__cz0AL"};